import { Button, Dialog, DialogActions, Box, DialogContent, IconButton, DialogTitle, FormHelperText, TextField, Select, MenuItem, Divider } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setSiteDetailsData } from '../../../redux/siteDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { CustomPhoneInput } from '../../../utils/customPhoneInput';
import { useCallback, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import Iconify from '../../Iconify';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/sites/addSiteDialog.css';

export const UpdateSiteLocalisation = ({ openUpdateLocalisation, setOpenUpdateLocalisation }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const authenticatedUser = useSelector(state => state.AuthenticatedUser);
    const siteDetailsData = useSelector((state) => state.SiteDetailsData || {});

    const [regions, setRegions] = useState([]);

    const formik = useFormik({

        initialValues: {
            address: siteDetailsData?.address || '',
            region_id: siteDetailsData?.region?.id,
            postal_code: siteDetailsData?.postal_code,
            city: siteDetailsData?.city || '',
            address_line_2: siteDetailsData?.address_line_2 || '',
            phone_number: siteDetailsData?.phone_number || '',
        },

        validationSchema: Yup.object().shape({
            address: Yup.string().optional(),
            region_id: Yup.string().required(t('isRequired')),
            postal_code: Yup.string().optional(),
            city: Yup.string().optional(),
            address_line_2: Yup.string().optional(),
            phone_number: Yup.string().optional(),
        }),

        onSubmit: async (values) => {
            try {
                // Send the FormData object via Axios
                const response = await axios.patch(`site/${siteDetailsData.id}`, values);

                if (response.status === 200 || response.status === 201) {
                    dispatch(setSuccessfullModifyDialog({ open: true, type: 'Modifier la localisation de site' }));
                    dispatch(setSiteDetailsData({
                        ...siteDetailsData,
                        region: response?.data?.region,
                        address: response?.data?.address,
                        postal_code: response?.data?.postal_code,
                        address_line_2: response.data?.address_line_2,
                        city: response?.data?.city,
                        phone_number: response?.data?.phone_number,
                    }));
                    setOpenUpdateLocalisation(false);
                }

            } catch (error) {
                console.error('Error updating site:', error);
                CustomErrorLogger(error, 'Error updating site in UpdateSiteLocalisation');
            }
        },
    });

    const { handleSubmit, values, handleChange, handleBlur, setFieldValue, touched, errors } = formik;

    const handleClose = useCallback(() => setOpenUpdateLocalisation(false), [setOpenUpdateLocalisation]);

    const fetchRegions = useCallback(async () => {
        try {
            const response = await axios.get('region');
            if (response.status === 200 || response.status === 201) {
                setRegions(response.data);
            }
        } catch (error) {
            console.error('Error fetching regions:', error);
            CustomErrorLogger(error, "error fetching regions in UpdateSiteLocalisation");
        }
    }, []);

    useEffect(() => {
        fetchRegions()
    }, [fetchRegions]);

    return (
        <Dialog open={openUpdateLocalisation} fullWidth maxWidth="md">
            <IconButton onClick={handleClose} className='addSite_icon_button'>
                <Iconify icon={"material-symbols:close"} className='addSite_close_icon' />
            </IconButton>
            <DialogTitle className='addSite_dialog_title'>Modifier la localisation de site</DialogTitle>
            <Divider />
            <form onSubmit={handleSubmit}>
                <DialogContent className='addSite_dialog_content'>
                    {authenticatedUser.user_region_ids.length > 1 &&
                        <Box className='modifierLocalisationMetier_helper_selct_box'>
                            <FormHelperText id="outlined-weight-helper-text" className="modifierLocalisationMetier_helper_text">{t('Region')}</FormHelperText>
                            <Select
                                className={`addSite_select_metier`}
                                value={values.region_id}
                                onChange={(e) => handleChange(e)}
                                onBlur={handleBlur}
                                options={regions}
                                name="region_id"
                                error={touched.region_id && Boolean(errors.region_id)}
                            >
                                {regions?.map((region) => (
                                    <MenuItem
                                        key={region.id} className='modifierLocalisationMetier_select_metier_item' value={region.id}>
                                        {region.name}
                                    </MenuItem>
                                ))}
                            </Select>
                            {touched.region_id && errors.region_id && (
                                <FormHelperText error className='modifierLocalisationMetier_select_helper'>{errors.region_id}</FormHelperText>
                            )}
                        </Box>
                    }
                    <Box className="addSite_helper_field_box">
                        <FormHelperText id="outlined-weight-helper-text" className="addSiteInputTitle">Adresse (optionnel)</FormHelperText>
                        <TextField
                            fullWidth
                            placeholder="Entrez l'adresse"
                            value={values.address}
                            className='addSite_InputField'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="address"
                            error={touched.address && Boolean(errors.address)}
                            helperText={touched.address && errors.address}
                        />
                    </Box>
                    <Box className="updateCompanyAddress_helper_input_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateCompanyAddressInputTitle">Complément d'adresse (optionnel)</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.address_line_2}
                            className='updateCompanyAddress_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="address_line_2"
                            error={touched.address_line_2 && Boolean(errors.address_line_2)}
                            helperText={touched.address_line_2 && errors.address_line_2}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                    <Box className="addSite_helper_field_box">
                        <FormHelperText id="outlined-weight-helper-text" className="addSiteInputTitle">Postal code (optionnel)</FormHelperText>
                        <TextField
                            fullWidth
                            placeholder='Entrez postal code'
                            value={values.postal_code}
                            className='addSite_InputField'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="postal_code"
                            error={touched.postal_code && Boolean(errors.postal_code)}
                            helperText={touched.postal_code && errors.postal_code}
                        />
                    </Box>
                    <Box className="addSite_helper_field_box">
                        <FormHelperText id="outlined-weight-helper-text" className="addSiteInputTitle">Ville (optionnel)</FormHelperText>
                        <TextField
                            fullWidth
                            placeholder='Entrez la ville'
                            value={values.city}
                            className='addSite_InputField'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="city"
                            error={touched.city && Boolean(errors.city)}
                            helperText={touched.city && errors.city}
                        />
                    </Box>
                    <Box className="addUser_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="addUserInputTitle">Numéro Tel (optionnel)</FormHelperText>
                        <CustomPhoneInput
                            name="phone_number"
                            value={values.phone_number}
                            onChange={(value) => setFieldValue('phone_number', value)}
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='addSite_dialog_actions'>
                    <Button className='addSite_button_annuler' onClick={handleClose}>{t('Annuler')}</Button>
                    <Button className='addSite_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};